module.exports = __webpack_public_path__ + "static/media/arrow_1.00f91b63.svg";